import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { buyers } from "../data/content";
const FIRST_DELAY = 6000;
const SHOW_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutes, setMinutes] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let cycleTimer: number;
    const show = () => {
      setMinutes(1 + Math.floor(Math.random() * 9));
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        cycleTimer = window.setTimeout(() => {
          setIndex(i => (i + 1) % buyers.length);
          show();
        }, GAP);
      }, SHOW_FOR);
    };
    const startTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(startTimer);
      window.clearTimeout(hideTimer);
      window.clearTimeout(cycleTimer);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-[92px] left-3 right-3 z-50 sm:right-auto md:bottom-6 md:left-6" aria-live="polite" data-id="element-23" data-mp="1fvsnt3ix9kny">
      <AnimatePresence data-id="element-24" data-mp="1axqwjvbcef1e">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex max-w-sm items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_12px_40px_-10px_rgba(27,17,64,0.35)] ring-1 ring-sand" data-id="element-25" data-mp="n74vwp3o3x1f">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brand-700 font-bold text-white" data-id="element-26" data-mp="28mkgvs4oxt72">
              {buyer.name.charAt(0)}
            </span>
            <div className="min-w-0" data-id="element-27" data-mp="2aobgkvh5af07">
              <p className="text-sm leading-snug text-ink" data-id="element-28" data-mp="2fneapkvl70te">
                <strong data-id="element-29" data-mp="2fltgjwd6pjw2">{buyer.name}</strong> from {buyer.place}
              </p>
              <p className="text-sm leading-snug text-muted" data-id="element-30" data-mp="2ko27kn6hybvj">just bought the Sensory Decision Map™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-go-deep" data-id="element-31" data-mp="2plbvtzi5ghhs">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-32" data-mp="1rzemospntoii" />
                Verified purchase · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-muted hover:bg-sand" aria-label="Close notification" data-id="element-33" data-mp="21vpx1d5ow4ab">
              <XIcon className="h-4 w-4" data-id="element-34" data-mp="197c070qc7e0c" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}